import { createUseStyles } from 'react-jss';
import { BaseButtonProps } from './';
import { Classes } from 'jss';

export const useBaseButtonStyles: (
  data?: BaseButtonProps & {
    theme?: Jss.Theme;
  },
) => Classes<'root' | 'children' | 'disabled' | 'loader' | 'loading'> = createUseStyles({
  root: ({ pressedColors, focusColors, defaultColors, hoverColors, small, minWidth, allCaps }: BaseButtonProps) => {
    return {
      minWidth: minWidth === undefined ? '' : minWidth,
      borderRadius: '25px',
      borderWidth: '2px',
      borderStyle: 'solid',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px',
      textTransform: allCaps ? 'uppercase' : 'none',
      letterSpacing: allCaps ? '2px' : 'none',
      fontFamily: 'inherit',
      height: small ? '32px' : '48px',
      outline: 'none',
      padding: '0 24px',
      position: 'relative',
      textDecoration: 'none',
      transition: 'opacity 500ms ease 0s, background-color 300ms ease 0s, border-color 300ms ease 0s',
      ...defaultColors,
      '&:hover': {
        ...hoverColors,
      },
      '&:focus-visible': {
        ...focusColors,
        borderWidth: '3px',
        padding: '0 23px',
      },
      '&:active': {
        ...pressedColors,
      },
    };
  },
  children: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  disabled: ({ disabledColors }: BaseButtonProps) => {
    return {
      ...disabledColors,
      pointerEvents: 'none',
    };
  },
  loader: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  loading: {
    visibility: 'hidden',
  },
});
